"use strict";

module.exports = require("./SearchProviderView.js");